<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="record-view">
                        <div class="table-head"></div>
                        <div class="table-view">
                            <vuescroll>
                                <table>
                                    <thead>
                                        <tr>
                                            <td>序号</td>
                                            <td>昵称</td>
                                            <td>被招募时间</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in record_list" :key="index">
                                            <td style="width: 120px;"><div class="text-overflow-1">{{ (index + 1) }}</div></td>
                                            <td class="nick">{{ item.nickName }}</td>
                                            <td class="time">
                                                {{ item.bindTime.slice(5) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </vuescroll>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.record-modal{
    width: 731px;
    height: 644px;
    background-image: url(~@/assets/images/modal/bg-modal-record.png);
}

.title{
    width: 397px;
    height: 42px;
    margin: 0 auto 25px;
    background-image: url(~@/assets/images/modal/title-record.png);    
}

.table-view{
    height: 445px;
}

.table-view{
    width: 620px;
    margin-left: 50px;
    font-size: 20px;
}

table{
    width: 600px;
    margin: 0 auto;
    text-align: center;
    color: #3b3f3e;
    border-collapse: collapse;
}

thead{
    td{
        font-size: 20px;
        color: #5b734f;
    }
}

tbody td{
    height: 60px;
}

tr{
    font-size: 20px;
    color: #3b3f3e;    
    margin-bottom: 20px;
    
}

tbody tr{
    border-bottom: 1px solid #d7dace;
}

.time{
    color: #9b9f90;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            record_list : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        console.log(this.record_list);
    },           
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
        closeModal(){
            this.destroyElement()
        },     
    },    
}
</script>